<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/X1WQGr/tc-custom/9781617452703.jpg?1730637004344" alt="This image is the cover for the book Wen Redmond's Digital Fiber Art"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wen Redmond's Digital Fiber Art
      </h1>
      <p class="bookDescription body article font2">
        <p>Fine art meets fabric!  Compose, create, and print innovative art quilts starting from your own digital photographs—even those from your phone! Well-known fiber artist Wen Redmond starts with the tools and equipment you'll need—any image editing software and a standard inkjet printer—and teaches you to alter images, print them on a variety of fibers, and accentuate them with stitching. With a sense of adventure, even a beginner can apply these techniques to create new and innovative works of art.   - Transform your photographs into matchless works of art with mixed-media techniques and quilting  - Explore inkjet printing on almost anything! Design with fabric, paper, and other substrates  - Get photo editing, layering, and printing tips from respected fiber artist and teacher Wen Redmond  - Learn new approaches to digital printing—perfect for quilters, fabric and paper artists, digital artists, mixed-media artists, photographers, art teachers, and more</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Wen Redmond
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishing, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?eb10d99a